import {Basic, Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getUnitsPricing} from '../utils/getUnitsPricing'

type Props = {
  availability?: Ventrata.Availability
  usedUnits: Ventrata.Unit[]
  counters: Record<string, number>
  currency: Basic.Currency
}

export const TotalPerUnit = ({availability, usedUnits, counters, currency}: Props) => {
  const unitsPricing = getUnitsPricing(availability)

  const total = unitsPricing
    ? usedUnits.reduce((result, unit) => {
        return result + unitsPricing[unit.id] * counters[unit.id]
      }, 0)
    : null

  return total !== null ? (
    <div className="py-4 flex justify-between font-bold">
      <div>Total</div>
      <div>{formatMoney(total, currency)}</div>
    </div>
  ) : null
}
